import { IQueryConditionHandler } from "./iquerycondition.handler";

import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { QueryCondition } from '../../entity/querycondition';
import { DateValue } from '../../entity/conditionvalue/datevalue';

export class DateHandler implements IQueryConditionHandler{
    convert(qc: QueryCondition) {
        const drv = (qc.value as DateValue);
        return Object.keys(drv).length > 0 && drv.value ? [{
            'FilterField' : qc.fieldCode,
            'Compare' : qc.control.compareType, //自定义
            'Value' : drv.value,
            'Relation' : RelationType.And,
            'Expresstype':ValueType.Value
        }] : [];
    }
}